/**
 * Created by bootdo.
 * 角色相关api
 */
import * as API from '..'
import $const from '../../common/constant'

export default {
  /**
   * create async export task
   * @param params
   * @returns {Promise<*>}
   */
  async: params => {
    return API.POST($const.apiServer.Tranning + '/export/async', params);
  },
  /**
   * get async export taask  status
   * @param params
   * @returns {Promise<*>}
   */
  asyncStatus: params => {
    return API.POST($const.apiServer.Tranning + '/export/async/statusV2', params, true);
  },
}



// WEBPACK FOOTER //
// ./src/api/training/api_export.js